import Permissions from './permissions';
export default Permissions;


// WEBPACK FOOTER //
// ./src/universal/components/permissions/index.js